var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTreatments = function SvgTreatments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M4.238 2.253a.24.24 0 1 0 .16-.24h-.8A1.6 1.6 0 0 0 2 3.614v3.996a4.796 4.796 0 0 0 9.593 0V3.612a1.6 1.6 0 0 0-1.599-1.598h-.8a.17.17 0 1 0 .24.24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "M6.796 12.404v.8a4.796 4.796 0 1 0 9.593 0v-3.198M16.39 10.005a1.599 1.599 0 1 0 0-3.197 1.599 1.599 0 0 0 0 3.197"
  })));
};
export default SvgTreatments;